var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bigButton"}},[_c('button',{staticClass:"buttons",class:{'button_click': _vm.isClick},attrs:{"disabled":_vm.isClick},on:{"click":_vm.buttonClick}},[_vm._t("default",[_vm._v("确认")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }